import React, { useReducer } from 'react';
import firebase from '../firebase/firebase'
import FirebaseContext from './FirebaseContext'
import FirebaseReducer from './FirebaseReducer'

import { 
    SET_APPS,
    SET_CATEGORIES 
} from "../types";

const FirebaseState = ({ children }) => {

    const initialState = {
        
        categories: [],
        apps: []

    }

    const [ state, dispatch ] = useReducer( FirebaseReducer, initialState )

    const addMessage = async ( collection ,data ) => await firebase.addDocument( collection, data )

    const fetchCategories = async () => {
        
        const collection = await firebase.db.collection( "categories" ).get()

        const response = collection.docs.map( doc => ({ id: doc.id, ...doc.data() }))

        dispatch({
            type: SET_CATEGORIES,
            payload: response
        })   
    }

    const fetchApps = async () => {
        
        const collection = await firebase.db.collection( "apps" ).get()

        const response = collection.docs.map( doc => ({ id: doc.id, ...doc.data() }))

        dispatch({
            type: SET_APPS,
            payload: response
        })  

    }

    return ( 

        <FirebaseContext.Provider
            value = {{
                categories: state.categories,
                apps: state.apps,
                addMessage,
                fetchCategories,
                fetchApps
            }}
        >
            { children }
        </FirebaseContext.Provider>

    );
}
 
export default FirebaseState;